import {Cell} from "react-table";
import React from "react";
import {FormattedMessage} from "react-intl";

/**
 * Rendert die "Handlungen"-Tabellen-Zelle für das Einreichungslisting
 *
 * @param cell
 * @constructor
 */
const TasksColumn: (cell: Cell) => JSX.Element = (cell: Cell) => {
    if (cell.row.values.tasks > 0) {
        return (
            <span>
                <FormattedMessage id='myarea.listing.column.body.tasks.existing'/>
                <span className='badge badge-tasks'>
                    {cell.row.values.tasks}
                    <i className='fa fa-exclamation-circle'/>
                </span>
            </span>
        );
    }

    return (
        <FormattedMessage id='myarea.listing.column.body.tasks.none'/>
    );
}

export default TasksColumn;